import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from './store/store';
import Locales from './locales/vue-i18n-locales.generated';

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: store.state.user.language,
  fallBackLocale: 'de',
  messages: Locales,
});

export default i18n;
